var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button, Flex, Spin, Tag, theme, Typography, } from '@robinpowered/ui-kit';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../context/ConfigContext';
import { useEventApi } from '../../hooks/useEvent/useEventApi';
import { useEventDetailContext } from '../context/EventDetailContextProvider';
import { faCircleCheck } from '@awesome.me/kit-cf858715fd/icons/classic/light';
import { useCheckInStatus } from '../hooks/useCheckInStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { EventDetailsSuccessActions } from '../types';
export var CheckInStatus = function (_a) {
    var timeFormat = _a.timeFormat, spaceId = _a.spaceId;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var _b = useEventDetailContext(), event = _b.event, timezone = _b.timezone, onError = _b.onError, loadingEvent = _b.loadingEvent, onSuccess = _b.onSuccess, spaceData = _b.spaceData;
    var spaceInvitee = spaceData.get(spaceId);
    var _c = useConfig(), accessToken = _c.accessToken, environmentUrls = _c.environmentUrls, tenantId = _c.tenantId, userContext = _c.userContext;
    var currentOrg = userContext.currentOrg, currentUser = userContext.currentUser;
    var _d = __read(useState(false), 2), eventConfirmed = _d[0], setEventConfirmed = _d[1];
    var _e = __read(useState(false), 2), confirmingEvent = _e[0], setConfirmingEvent = _e[1];
    var _f = __read(useState(false), 2), confirmError = _f[0], setConfirmError = _f[1];
    var _g = __read(useState(false), 2), locationSettingsLoading = _g[0], setLocationSettingsLoading = _g[1];
    var _h = __read(useState(undefined), 2), locationSettings = _h[0], setLocationSettings = _h[1];
    var _j = useEventApi({
        onError: onError,
        accessToken: accessToken,
        apiUrl: environmentUrls.apiUrl,
        baseApiUrl: environmentUrls.baseApiUrl,
        tenantId: tenantId,
        currentOrg: currentOrg,
    }), confirmEvent = _j.confirmEvent, fetchLocationSettings = _j.fetchLocationSettings;
    useEffect(function () {
        if (!spaceInvitee)
            return;
        setEventConfirmed(!!(spaceInvitee === null || spaceInvitee === void 0 ? void 0 : spaceInvitee.confirmation));
        setConfirmError(false);
    }, [spaceInvitee]);
    var locationId = useMemo(function () {
        var _a;
        return (_a = spaceInvitee === null || spaceInvitee === void 0 ? void 0 : spaceInvitee.location) === null || _a === void 0 ? void 0 : _a.id;
    }, [spaceInvitee]);
    useEffect(function () {
        if (!locationId) {
            setLocationSettings(undefined);
            return;
        }
        var cancelled = false;
        setLocationSettingsLoading(true);
        fetchLocationSettings(locationId)
            .then(function (settings) {
            if (cancelled)
                return;
            setLocationSettings(settings);
        })
            .finally(function () {
            if (!cancelled) {
                setLocationSettingsLoading(false);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [fetchLocationSettings, locationId]);
    var canAttemptConfirm = currentUser.id;
    var checkInState = useCheckInStatus({
        event: event,
        currentUser: currentUser,
        locationSettings: locationSettings,
    });
    var handleConfirmEvent = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var userId, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event === null || event === void 0 ? void 0 : event.id) || !currentUser.id || !checkInState.canUserConfirmCheckIn)
                        return [2 /*return*/];
                    userId = Number(currentUser.id);
                    if (Number.isNaN(userId))
                        return [2 /*return*/];
                    setConfirmingEvent(true);
                    setConfirmError(false);
                    return [4 /*yield*/, confirmEvent({
                            eventId: event.id,
                            userId: userId,
                        })];
                case 1:
                    success = _a.sent();
                    if (success) {
                        setEventConfirmed(true);
                        onSuccess(EventDetailsSuccessActions.CHECK_IN_EVENT);
                    }
                    else {
                        setConfirmError(true);
                    }
                    setConfirmingEvent(false);
                    return [2 /*return*/];
            }
        });
    }); }, [
        checkInState.canUserConfirmCheckIn,
        confirmEvent,
        currentUser.id,
        event === null || event === void 0 ? void 0 : event.id,
        onSuccess,
    ]);
    if (!event || event.is_all_day) {
        return null;
    }
    if (loadingEvent || locationSettingsLoading) {
        return (_jsx(Container, { children: _jsx(Spin, { size: "small" }) }));
    }
    if (eventConfirmed) {
        return (_jsx(Container, { children: _jsxs(Tag, { variant: "outlined", style: {
                    backgroundColor: token.colorSuccessBg,
                    borderColor: token.colorSuccessBorder,
                    color: token.colorText,
                    marginInlineEnd: 0,
                }, children: [_jsx(FontAwesomeIcon, { icon: faCircleCheck, style: { color: token.colorSuccess, marginRight: 4 } }), t('eventDetails.checkin.confirmed')] }) }));
    }
    var isCheckInWindowOpen = checkInState.isCheckInWindowOpen, canUserConfirmCheckIn = checkInState.canUserConfirmCheckIn, isPastEvent = checkInState.isPastEvent, isCurrentEvent = checkInState.isCurrentEvent;
    if (!isCheckInWindowOpen && !isPastEvent && !isCurrentEvent) {
        return (_jsx(Container, { children: _jsxs(Tag, { variant: "outlined", style: {
                    color: token.colorText,
                    marginInlineEnd: 0,
                }, children: [_jsx(FontAwesomeIcon, { icon: faExclamationCircle, style: { marginRight: 4 } }), t('eventDetails.checkin.time', {
                        time: checkInState.checkInStartTime.tz(timezone).format(timeFormat),
                    })] }) }));
    }
    if (!isCheckInWindowOpen || isPastEvent || !canUserConfirmCheckIn) {
        return null;
    }
    return (_jsx(Container, { children: _jsxs(Flex, { vertical: true, gap: 8, children: [checkInState.ampEnabled ? (_jsx(Typography.Text, { type: "secondary", children: t('eventDetails.checkin.by', {
                        time: checkInState.checkInByTime.tz(timezone).format(timeFormat),
                    }) })) : null, _jsx(Button, { type: "default", loading: confirmingEvent, onClick: handleConfirmEvent, disabled: !canAttemptConfirm, style: { width: '100%' }, children: t('eventDetails.checkin.label') }), confirmError ? (_jsx(Typography.Text, { type: "danger", children: t('eventDetails.checkin.error') })) : null] }) }));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1;
